'use client';

import { c as _c } from "react/compiler-runtime";
import { useStore } from 'jotai';
import { useRef } from 'react';
import { useAppEffects } from '@/app/[locale]/_hooks/useAppEffects';
import { mainBgColorAtom } from '@/atoms';
import { NavActions } from '@/components/nav-actions';
import { SidebarInset, SidebarTrigger } from '@/components/ui/sidebar';
import { LIGHT_THEME_COLOR } from '@/constants/theme';
import { useAtomEffect, useStyleObserver } from '@sub-vocab/utils/hooks';
import { isServer } from '@sub-vocab/utils/lib';
export function AppSidebarInset(t0) {
  const $ = _c(9);
  const {
    children
  } = t0;
  const ref = useRef(null);
  const store = useStore();
  let t1;
  if ($[0] !== store) {
    t1 = t2 => {
      const [t3] = t2;
      const {
        value
      } = t3;
      store.set(mainBgColorAtom, value || LIGHT_THEME_COLOR);
    };
    $[0] = store;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      properties: ["background-color"]
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  useStyleObserver(ref, t1, t2);
  let t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = (_, set) => {
      if (isServer || !ref.current) {
        return;
      }
      set(mainBgColorAtom, window.getComputedStyle(ref.current).backgroundColor);
    };
    t4 = [];
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  useAtomEffect(t3, t4);
  useAppEffects();
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="flex h-full flex-1 gap-2"><div className="flex p-2 md:hidden"><SidebarTrigger className="size-8" /></div></div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <header className="flex h-14 shrink-0 items-center gap-2">{t5}<div className="ml-auto px-3 pr-4"><NavActions /></div></header>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== children) {
    t7 = <SidebarInset ref={ref}>{t6}{children}</SidebarInset>;
    $[7] = children;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  return t7;
}